import { z } from 'zod';
export const userRoleSchema = z.enum(['admin', 'user']);
export const loginRequestSchema = z.object({
    username: z.string().trim().min(1, 'Kullanıcı adı zorunlu'),
    password: z.string().min(1, 'Şifre zorunlu'),
});
/** Oturum sahibinin kendi bilgisi. Şifre alanı hiçbir yanıtta yer almaz. */
export const currentUserSchema = z.object({
    id: z.string().uuid(),
    username: z.string(),
    fullName: z.string(),
    role: userRoleSchema,
});
export const loginResponseSchema = z.object({
    accessToken: z.string(),
    refreshToken: z.string(),
    user: currentUserSchema,
});
export const refreshRequestSchema = z.object({
    refreshToken: z.string().min(1),
});
//# sourceMappingURL=auth.js.map